import PropTypes from 'prop-types'
import React, { useState} from 'react'
import { useDrop } from '../contexts/DropContext'
import {FaFileAlt } from "react-icons/fa";
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip as ReactTooltip} from "react-tooltip"

const Button = ({sessionID, color, loadStatus }) => {
  const [buttonState, changeButtonState] = useState(true)
  const buttonClick = () => {
    changeButtonState(updateStatus())    
  }

  const project = useDrop().currentDrop

  const updateStatus = async () => {
    const res = await fetch('https://us-central1-openscopedataback.cloudfunctions.net/app/api/table/' + project + "/" + sessionID,{
        method: 'POST',
        headers: {
          'status': 'initalized'
        }
    })
    const res2 =  await fetch('https://us-central1-openscopedataback.cloudfunctions.net/app/api/table/status/' + project
                              + '/' + sessionID)
    const data = await res2.json()
    console.log(data)
    loadStatus(data, sessionID)
    return data
  }
 
  return (
    <button
      onClick={buttonClick}
      id = {sessionID + "init"}
      style={{
        backgroundColor: color,
        width: '40px',
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
      class='btn'
      variant="contained"
      data-tooltip-content = "Initiate NWB Conversion"
    >
    <div style={{ justifyContent: "center" }}>
      <FaFileAlt/>
      <ReactTooltip anchorId={sessionID + 'init'}/>
    </div>
    </button>
  )
}


Button.defaultProps = {
  color: 'steelblue',
  sessionID: 837360280,
}

Button.propTypes = { 
  sessionID: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
}

export default Button